import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE,
  DeliveryFunctionNetworkInterface,
} from './deliveryFunctionNetworkInterface.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getDeliveryFunctionNetworkInterfaceList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>> {
  return http.get(`${API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE}/${deliveryFunctionId}`);
}

export function getDeliveryFunctionNetworkInterface(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>> {
  return http.get(`${API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE}/${deliveryFunctionId}/${id}`);
}

export function createDeliveryFunctionNetworkInterface(
  deliveryFunctionId: string,
  body: WithAuditDetails<DeliveryFunctionNetworkInterface>,
): AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>> {
  return http.post(`${API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE}/${deliveryFunctionId}`, body);
}

export function updateDeliveryFunctionNetworkInterface(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<DeliveryFunctionNetworkInterface>,
): AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>> {
  return http.put(`${API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE}/${deliveryFunctionId}/${id}`, body);
}

export function deleteDeliveryFunctionNetworkInterface(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<DeliveryFunctionNetworkInterface>> {
  return http.delete(`${API_PATH_DELIVERY_FUNCTION_NETWORK_INTERFACE}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
